<template>
  <div class="form-group form-group--select" v-bind:class="getClass()">

    <div class="row">
      <div v-bind:class="`col-sm-${component.size}`">
        <label>{{ component.label }}
          <span class="required" v-if="isRequired()">*</span>
        </label>
        <div class="select-container">
          <v-select
            class="style-chooser"
            :id="component.key"
            v-model="selectedValue"
            @search="fetchOptions"
            @open="visibilityChanged(true)"
            @close="visibilityChanged(false)"
            placeholder="Selecione uma opção"
            :multiple="component.isMultiselect===true"
            v-on:focus="focusHandler()"
            @search:blur="blurHandler()"
            v-validate="setRules()"
            v-bind:name="component.key"
            v-bind:disabled="disabledHandler()"
            v-bind:data-vv-name="component.key"
            :getOptionLabel="option => option && Array.isArray(option.label) ? option.label[0] : option && option.label ? option.label : option"
            :options="values">
            {{ values }}
            <template v-slot="option" v-slot-scope="option">
              <span v-for="(label, index) in option.label" :key="index">
                {{ label }}
              </span>
            </template>
            <template #no-options>
              <span v-if="!errors">Nenhum registro encontrado.</span>
            </template>
          </v-select>
        </div>
        <span class="help-block help-block--bottom" v-if="errors.has(component.key)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14">
            <g transform="translate(-252 -635)">
              <rect class="cls-1" width="14" height="14" transform="translate(252 635)" />
              <path class="cls-2"
                    d="M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z"
                    transform="translate(251 634)" />
            </g>
          </svg>
          {{ (errors.first(component.key)) }}</span>
        <span class="help-block help-block--bottom"
              v-if="!errors.has(component.key) && component.description">{{ component.description }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
// https://br.vuejs.org/v2/guide/mixins.html
import component from '@/mixins/component'
import 'select2/dist/js/select2.full.min'
import 'select2/dist/css/select2.min.css'
import { mapState } from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import formTransformer from '@/services/formTransformer'

const normalizeSingleSelectLabel = (label) => {
  if (Array.isArray(label)) {
    return label
  }

  if (label === undefined || label === null) {
    return []
  }

  return [label]
}

const normalizeSingleSelectValue = (option) => {
  const value = Array.isArray(option) ? option[0] || null : option

  if (value && typeof value === 'object') {
    return [{ ...value, label: normalizeSingleSelectLabel(value.label) }]
  }

  return value
}

const normalizeSingleSelectDisplayValue = (option) => {
  const value = Array.isArray(option) ? option[0] || null : option

  if (value && typeof value === 'object' && Array.isArray(value.label)) {
    return { ...value, label: value.label[0] || '' }
  }

  return value
}

const shouldNormalizeSingleSelectValue = (value) => {
  if (!value) {
    return false
  }

  if (!Array.isArray(value)) {
    return true
  }

  const option = value[0]
  return option && typeof option === 'object' && !Array.isArray(option.label)
}

export default {
  mixins: [component],
  props: ['component'],
  inject: ['$validator'],
  name: 'component-select',
  components: {
    vSelect
  },
  data () {
    return {
      isFocus: false,
      isValue: false,
      isErrors: false,
      values: [],
      novosValores: [],
      teste: [],
      valueInput: ''
    }
  },
  computed: {
    ...mapState({
      components: state => state.formJson.components,
      variables: state => state.config.variables,
      json: state => state.config.json,
      clientKey: state => state.config.clientKey
    }),
    selectedValue: {
      get () {
        if (this.component.isMultiselect === true) {
          return this.component.data.currentValue
        }

        return normalizeSingleSelectDisplayValue(this.component.data.currentValue)
      },
      set (value) {
        if (this.component.isMultiselect === true) {
          this.component.data.currentValue = value
          return
        }

        this.component.data.currentValue = normalizeSingleSelectValue(value)
      }
    }
  },
  methods: {
    async getValues () {
      this.values = []
      if (this.component.data.sourceType === 'json') {
        for (let i = 0; i < this.component.data.json.length; i++) {
          this.values.push({
            label: this.component.data.json[i][this.component.data.propertyLabel],
            value: this.component.data.json[i][this.component.data.propertyValue]
          })
        }
      } else if (this.component.data.sourceType === 'values') {
        let valores = []
        valores = this.component.data.sourceValues
        valores.map(v => {
          this.values.push({
            label: v.label,
            value: v.value
          })
        })
      } else if (this.component.data.sourceType === 'injectedJson') {
        if (this.config.json) {
          this.component.data.injectedJson = this.component.data.injectedJson.replace('json', 'this.config.json')
          try {
            /* eslint-disable no-eval */
            let keyCustom = eval(this.component.data.injectedJson)

            if (keyCustom) {
              for (let i = 0; i < keyCustom.length; i++) {
                this.values.push({
                  label: keyCustom[i][this.component.data.propertyLabel],
                  value: keyCustom[i][this.component.data.propertyValue]
                })
              }
            }
          } catch (e) {
            // Ignore error
          }
        }
      }
    },
    fetchOptions (search, loading) {
    },
    visibilityChanged (visible) {
      const padding = visible ? 320 : null
      formTransformer.changeBottomPaddingPx(padding)
    },
    checkDefaultValue () {
      const defaultValue = this.component.data.defaultValue
      if (defaultValue.length < 0) {
        this.$set(this.component.data, 'currentValue', null)
      }

      const existsInValues = this.values.some(value => {
        const isValidForFirstCase = Array.isArray(defaultValue[0].label) &&
          defaultValue[0].label.every(label => value.label.includes(label)) &&
          value.value === defaultValue[0].value

        const isValidForSecondCase = typeof defaultValue[0].label === 'string' &&
          value.label === defaultValue[0].label &&
          value.value === defaultValue[0].value

        return isValidForFirstCase || isValidForSecondCase // Retorna verdadeiro se qualquer um dos casos for válido
      })
      if (!existsInValues) {
        this.$set(this.component.data, 'currentValue', null)
      }
    }
  },
  async created () {
    await this.getValues()
    this.setValue()
    if (this.component.isMultiselect !== true) {
      this.component.data.currentValue = normalizeSingleSelectValue(this.component.data.currentValue)
    }
    if (this.component.data.currentValue) {
      const value = normalizeSingleSelectDisplayValue(this.component.data.currentValue)
      this.valueInput = value && value.label
    }
  },
  watch: {
    'component.data.currentValue': function (after, before) {
      if (this.component.isMultiselect === true) {
        if (after && !Array.isArray(after)) {
          this.component.data.currentValue = [after]
        }
        return
      }

      if (shouldNormalizeSingleSelectValue(after)) {
        this.component.data.currentValue = normalizeSingleSelectValue(after)
      }
    }
  }
}
</script>

<style>
.select2-selection__rendered {
  background-color: #eff4fd !important;
}

.select2-dropdown {
  background-color: #eff4fd !important;
}

.select2-container--default .select2-selection--multiple {
  border: none;
}

.select2-container--default.select2-container--focus .select2-selection--multiple {
  border: none;
}

.vs--single .vs__selected {
  margin: 0;
}

input[type="search"] {
  -webkit-appearance: none;
  margin: 0;
}
</style>
